'use strict';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import { NavBar, NavButton } from '../../components/index.jsx';
import ManagementPageCard from '../../components/layout/ManagementPageCard.jsx';

/**
 * Admin pipeline tracker route shell (global). Content removed per product request.
 */
export class PipelineTrackerPage extends Component {
	render() {
		const { match } = this.props;
		return (
			<ManagementPageCard
				className="app-content"
				header={(
					<NavBar history={this.props.history} controlled={true} size="small">
						<NavButton to={match.url}>
							<span style={{ fontSize: '1.125rem', fontWeight: 500 }}>Pipeline Tracker</span>
						</NavButton>
					</NavBar>
				)}
			>
				{/* Avoid class "main": .HomeContainer .main applies display:flex and breaks nested form layout */}
				<Box sx={{ width: '100%', minWidth: 0, display: 'block' }} />
			</ManagementPageCard>
		);
	}
}

export default withRouter(PipelineTrackerPage);
